import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"

export default function DeklaracjaDostepnosci() {
  const seo = {
    title: "Deklaracja dostępności - Medicus-Dukla Sp. z o.o.",
    description:
      "Deklaracja dostępności cyfrowej serwisu internetowego Medicus-Dukla Sp. z o.o. w Dukli, sporządzona zgodnie z Ustawą o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych.",
    url: "https://medicusdukla.pl/deklaracja-dostepnosci",
  }

  return (
    <Layout pageClass={"sample-page"} bg={null}>
      <SEO title={seo.title} description={seo.description} url={seo.url} />

      <section data-g="container" className="o-privacy-policy">
        <h1 className="a-heading-small">Deklaracja dostępności</h1>

        <p>
          <strong>Medicus-Dukla Sp. z o.o.</strong> zobowiązuje się zapewnić
          dostępność swojej strony internetowej zgodnie z przepisami ustawy
          z dnia 4&nbsp;kwietnia 2019&nbsp;r. o&nbsp;dostępności cyfrowej stron
          internetowych i&nbsp;aplikacji mobilnych podmiotów publicznych.
          Oświadczenie w&nbsp;sprawie dostępności ma zastosowanie do strony
          internetowej{" "}
          <a href="https://medicusdukla.pl">https://medicusdukla.pl</a>.
        </p>

        <ul className="o-ddom__list">
          <li>
            Data ostatniej istotnej aktualizacji:{" "}
            <strong>17.06.2026</strong>
          </li>
        </ul>

        <h2 className="a-heading-small">Status pod względem zgodności z ustawą</h2>
        <p>
          Strona internetowa jest <strong>częściowo zgodna</strong> z ustawą
          z dnia 4&nbsp;kwietnia 2019&nbsp;r. o&nbsp;dostępności cyfrowej stron
          internetowych i&nbsp;aplikacji mobilnych podmiotów publicznych
          z&nbsp;powodu niezgodności lub wyłączeń wymienionych poniżej.
        </p>

        <h3>Treści niedostępne</h3>
        <ul className="o-ddom__list">
          <li>
            Część materiałów graficznych (np. mapy dojazdu osadzone z&nbsp;Map
            Google) może nie posiadać pełnej alternatywy tekstowej.
          </li>
          <li>
            Niektóre dokumenty PDF zamieszczone w&nbsp;serwisie mogły zostać
            opublikowane bez warstwy tekstowej / tagów struktury (skany).
          </li>
        </ul>

        <h3>Wyłączenia</h3>
        <ul className="o-ddom__list">
          <li>
            Mapy są wyłączone z&nbsp;obowiązku zapewniania dostępności
            (art.&nbsp;3 ust.&nbsp;2 pkt&nbsp;4 ustawy).
          </li>
        </ul>

        <h2 className="a-heading-small">
          Przygotowanie deklaracji w sprawie dostępności
        </h2>
        <ul className="o-ddom__list">
          <li>
            Deklarację sporządzono dnia:{" "}
            <strong>17.06.2026</strong>
          </li>
          <li>
            Deklarację sporządzono na podstawie{" "}
            <strong>samooceny</strong> przeprowadzonej przez podmiot publiczny.
          </li>
          <li>
            Data ostatniego przeglądu deklaracji:{" "}
            <strong>17.06.2026</strong>
          </li>
        </ul>

        <h2 className="a-heading-small">Informacje zwrotne i dane kontaktowe</h2>
        <p>
          W&nbsp;przypadku problemów z&nbsp;dostępnością strony internetowej
          prosimy o&nbsp;kontakt. Osobą kontaktową jest{" "}
          <strong>Marcin Krajmas</strong>.
        </p>
        <ul className="o-ddom__list">
          <li>
            E-mail:{" "}
            <strong>kontakt@medicusdukla.pl</strong>
          </li>
          <li>
            Telefon: <a href="tel:+48134330328">13&nbsp;43&nbsp;30&nbsp;328</a>
          </li>
        </ul>
        <p>
          Tą samą drogą można składać wnioski o&nbsp;udostępnienie informacji
          niedostępnej oraz składać żądania zapewnienia dostępności.
        </p>

        <h3>Procedura wnioskowo-skargowa</h3>
        <p>
          Każdy ma prawo do wystąpienia z&nbsp;żądaniem zapewnienia dostępności
          cyfrowej strony internetowej, aplikacji mobilnej lub jakiegoś ich
          elementu. Można także zażądać udostępnienia informacji za pomocą
          alternatywnego sposobu dostępu, np. przez odczytanie niedostępnego
          cyfrowo dokumentu, opisanie zawartości filmu bez audiodeskrypcji itp.
          Żądanie powinno zawierać dane osoby zgłaszającej żądanie, wskazanie,
          o&nbsp;którą stronę internetową chodzi oraz sposób kontaktu. Jeżeli
          osoba żądająca zgłasza potrzebę otrzymania informacji za pomocą
          alternatywnego sposobu dostępu, powinna także określić dogodny dla
          niej sposób przedstawienia tej informacji.
        </p>
        <p>
          Podmiot publiczny powinien zrealizować żądanie niezwłocznie, nie
          później niż w&nbsp;ciągu 7&nbsp;dni od dnia wystąpienia
          z&nbsp;żądaniem. Jeżeli dotrzymanie tego terminu nie jest możliwe,
          podmiot publiczny niezwłocznie informuje o&nbsp;tym wnoszącego
          żądanie, kiedy realizacja żądania będzie możliwa, przy czym termin ten
          nie może być dłuższy niż 2&nbsp;miesiące od dnia wystąpienia
          z&nbsp;żądaniem. Jeżeli zapewnienie dostępności cyfrowej nie jest
          możliwe, podmiot publiczny może zaproponować alternatywny sposób
          dostępu do informacji.
        </p>
        <p>
          W&nbsp;przypadku, gdy podmiot publiczny odmówi realizacji żądania
          zapewnienia dostępności lub alternatywnego sposobu dostępu do
          informacji, wnoszący żądanie może złożyć skargę w&nbsp;sprawie
          zapewnienia dostępności cyfrowej strony internetowej lub elementu
          strony internetowej. Po wyczerpaniu wskazanej wyżej procedury można
          także złożyć wniosek do{" "}
          <a
            href="https://www.rpo.gov.pl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rzecznika Praw Obywatelskich
            <span className="sr-only"> (otwiera się w nowej karcie)</span>
          </a>
          .
        </p>

        <h2 className="a-heading-small">Dostępność architektoniczna</h2>
        <p>
          Przychodnia <strong>Medicus-Dukla</strong>, ul.&nbsp;Trakt Węgierski
          16, 38-450 Dukla:
        </p>
        <ul className="o-ddom__list">
          <li>
            Do budynku prowadzi wejście dostosowane do potrzeb osób
            z&nbsp;niepełnosprawnością ruchową, w&nbsp;tym poruszających się na
            wózku (adaptacja wysokiego parteru do wymagań Standardu Dostępności
            POZ).
          </li>
          <li>
            W&nbsp;budynku zapewniono dostępność komunikacyjną pomieszczeń
            obsługujących pacjentów na poziomie parteru.
          </li>
          <li>
            Przed budynkiem wyznaczono miejsce parkingowe dla osób
            z&nbsp;niepełnosprawnością.
          </li>
          <li>
            Do budynku i&nbsp;wszystkich jego pomieszczeń można wejść
            z&nbsp;psem asystującym i&nbsp;psem przewodnikiem.
          </li>
          <li>
            W&nbsp;budynku funkcjonuje system kolejkowy oraz system
            przywoławczy.
          </li>
        </ul>

        <h2 className="a-heading-small">
          Informacja o dostępności tłumacza języka migowego
        </h2>
        <p>
          Zgodnie z&nbsp;ustawą z&nbsp;dnia 19&nbsp;sierpnia 2011&nbsp;r.
          o&nbsp;języku migowym i&nbsp;innych środkach komunikowania się osoba
          uprawniona (doświadczająca trwale lub okresowo trudności
          w&nbsp;komunikowaniu się) ma prawo do skorzystania z&nbsp;pomocy
          tłumacza polskiego języka migowego (PJM) podczas wizyty.
          Usługa jest <strong>bezpłatna</strong> dla osoby uprawnionej.
        </p>
        <p>
          Chęć skorzystania z&nbsp;tłumacza należy zgłosić co najmniej na{" "}
          <strong>3&nbsp;dni robocze</strong> przed planowaną wizytą (z&nbsp;wyłączeniem
          sytuacji nagłych) — telefonicznie pod numerem{" "}
          <a href="tel:+48134330328">13&nbsp;43&nbsp;30&nbsp;328</a> lub
          osobiście w&nbsp;rejestracji. Pacjent może również przyjść
          z&nbsp;własnym tłumaczem lub osobą przybraną.
        </p>

        <h2 className="a-heading-small">
          Dostęp do informacji w formie alternatywnej
        </h2>
        <p>
          Osoby ze szczególnymi potrzebami mogą zamówić udostępnienie dokumentu
          w&nbsp;dogodnej dla siebie formie (m.in. druk powiększony, tekst łatwy
          do czytania, nagranie audio, Polski Język Migowy, dostępny PDF). Aby
          złożyć takie zgłoszenie, prosimy o&nbsp;kontakt telefoniczny pod
          numerem podanym powyżej{" "}
          <a href="tel:+48134330328">13&nbsp;43&nbsp;30&nbsp;328</a> lub
          mailowy na adres{" "}
          <a href="mailto:kontakt@medicusdukla.pl">kontakt@medicusdukla.pl</a>.
        </p>
      </section>
    </Layout>
  )
}
